const nonReferralPricingProducts = ['12', '17'];
const acceptablePricingProductNames = ['Referrals', 'Referrals (Super Premium)', 'Geo-Targeted Referrals'];

export { nonReferralPricingProducts, acceptablePricingProductNames };
